@if (canInherit) {
  <div>
    <div [class]="{ 'd-flex': label != null, 'float-end': label == null }">
      @if (label != null) {
        <div>
          <ng-container [ngTemplateOutlet]="label"></ng-container>
        </div>
      }
      <!-- Toggle -->
      <div class="form-check ms-auto">
        <input
          class="form-check-input"
          #toggle
          [formControl]="inheritedFormControl"
          [id]="'inherited-toggle_' + id"
          (change)="update(toggle.checked)"
          type="checkbox"
        />
        <label class="form-label" [for]="'inherited-toggle_' + id">
          {{ 'general.inherited' | translate }}
        </label>
      </div>
    </div>
    <!-- Value -->
    @if (input != null) {
      <fieldset [attr.disabled]="inheritValue === true || null">
        <ng-container [ngTemplateOutlet]="input"></ng-container>
        <portal-form-validation-errors [controlName]="formControlName"></portal-form-validation-errors>
      </fieldset>
    }
  </div>
} @else {
  <div class="mb-1">
    <ng-container *ngTemplateOutlet="label"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="input"></ng-container>
  <portal-form-validation-errors [controlName]="formControlName"></portal-form-validation-errors>
}
